const state = {
    conversations: [],
    messages: [],
    selectedConversation: null,
};

export default state;

